import React, { useContext, useMemo } from 'react';
/** Creates a `UniqueIdSource` for use with our `UniqueIdContext` */
export function makeUniqueIdSource(prefix) {
    return {
        prefix: prefix,
        index: 0,
    };
}
/** Stores a `UniqueIdSource`. The provider for this should be placed in the root app component before you try using `useUniqueId` */
export var UniqueIdContext = React.createContext(makeUniqueIdSource('global'));
/**
 * Pulls the `UniqueIdContext` and returns a unique id while incrementing the context's index.
 *
 * This is useful for situations where we need to link components via `aria-owns` or similar.
 */
export function useUniqueId() {
    var idSource = useContext(UniqueIdContext);
    var value = useMemo(function () {
        var id = "".concat(idSource.prefix, "-").concat(idSource.index);
        // Increment the idSource's index so the next component that uses this will have an index one higher
        idSource.index++;
        return id;
    }, [idSource]);
    return value;
}
//# sourceMappingURL=useUniqueId.js.map